import { combineReducers } from "redux";

import { usersEntriesReducer } from "./Users/reducer";

export const usersReducer = combineReducers({ entries: usersEntriesReducer });